export enum InteractType {
    NONE = 0,
    LOC = 1, // object
    OBJ = 2, // item
    NPC = 3,
}
